import ImageZoom, { ImageZoomContext } from '@leuven2030/framework/Image/ImageZoom';
import { useContext, useEffect, useRef, useState } from 'react';
import PlayArrowIcon from '@material-ui/icons/PlayArrow';
import { css } from '@emotion/react';
import tw from 'twin.macro';

const ContentVideo = ({ data: { embed_title, embed_url } }) => {
  return (
    <div tw="mx-auto max-w-2xl flex flex-col  my-6 py-6 space-y-6">
      <p tw="text-xl text-primary-600 text-center">{embed_title}</p>
      <ImageZoom>
        <Video data={embed_url} />
      </ImageZoom>
    </div>
  );
};

const VideoCss = css`
  button {
    ${tw`pointer-events-none`}
  }
`;

const Video = ({
  data: { thumbnail_url, title, embed_url, width, height },
  ...rest
}) => {
  const [show, setShow] = useState(false);
  const { isZoomed } = useContext(ImageZoomContext);
  const videoRef = useRef<HTMLDivElement>();
  const videoId = embed_url.split('v=')[1].split('&')[0];

  function shouldShow() {
    return (
      !!videoRef.current.parentElement.getAttribute(
        'data-rmiz-modal-content'
      ) && isZoomed
    );
  }

  useEffect(() => {
    setShow(!!shouldShow());
  }, [videoRef, isZoomed]);

  return (
    <div
      tw=" w-full flex items-center justify-center"
      css={[{ height: 420 }, VideoCss]}
      ref={videoRef}
      {...rest}
    >
      <div tw="rounded-md  w-full h-full overflow-hidden max-w-2xl relative bg-black">
        {!show && (
          <div tw="mx-auto h-full flex items-center justify-center">
            <div tw="absolute left-0 top-0 w-full h-full bg-gray-200 bg-opacity-75 z-10 flex justify-center items-center pointer-events-none">
              <div tw="text-white p-2 bg-primary-500">
                <PlayArrowIcon tw="text-white w-16 h-16" />
              </div>
            </div>
            <img
              tw="object-cover w-full h-full"
              alt={title}
              src={thumbnail_url}
            />
          </div>
        )}
        {show && (
          <div tw="w-full h-full absolute top-0 left-0 flex items-center justify-center">
            <iframe
              width={1920}
              height={1080}
              tw="w-full h-full"
              src={`https://www.youtube.com/embed/${videoId}?feature=oembed&autoplay=1`}
              frameBorder={0}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen={true}
            />
          </div>
        )}
      </div>
    </div>
  );
};

ContentVideo.type = 'embed';

export default ContentVideo;
